import { DelegatedObservableArrayChangeListenner, ObservableArray, View } from "binder"
import { SaleBenefitsReportViewModel, Item } from "./saleBenefitsReport-viewModel"

export class SaleBenefitsReportView extends View<SaleBenefitsReportViewModel>{
    GetViewUniqueId(): string {
        return "V-F18D28CD-0149-428B-9B12-EA58282BC77F"
    }
    loadHtml(): string {
        let element = require('./saleBenefitsReport.html').default;
        let style = require('./saleBenefitsReport.less');
        return element;
    }
    constructor() {
       super();
    }

    public set items(v: ObservableArray<Item>) { 
        this._items = v; 
        let listenner = new DelegatedObservableArrayChangeListenner(this,x=>this.calculateSum());
        this._items.addChangeListenner(listenner);
    } public get items(): ObservableArray<Item> { return this._items;} private _items: ObservableArray<Item>;
    public set filterItems(v: ObservableArray<Item>) { 
        this._filterItems = v; 
        let listenner = new DelegatedObservableArrayChangeListenner(this,x=>this.calculateSum());
        this._filterItems.addChangeListenner(listenner);
        //this.calculateSum();
    } public get filterItems(): ObservableArray<Item> { return this._filterItems;} private _filterItems: ObservableArray<Item>;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set from(v: moment.Moment) { this._from = v; } public get from(): moment.Moment { return this._from;} private _from: moment.Moment;
    public set until(v: moment.Moment) { this._until = v; } public get until(): moment.Moment { return this._until;} private _until: moment.Moment;
    public set sumSetPrice(v: number) { this._sumSetPrice = v; } public get sumSetPrice(): number { return this._sumSetPrice;} private _sumSetPrice: number;
    public set sumSoldPrice(v: number) { this._sumSoldPrice = v; } public get sumSoldPrice(): number { return this._sumSoldPrice;} private _sumSoldPrice: number;
    public set benefitRateMean(v: number) { this._benefitRateMean = v; } public get benefitRateMean(): number { return this._benefitRateMean;} private _benefitRateMean: number;
    public set expectedBenefitMean(v: number) { this._expectedBenefitMean = v; } public get expectedBenefitMean(): number { return this._expectedBenefitMean;} private _expectedBenefitMean: number;
    public set realDollarMean(v: number) { this._realDollarMean = v; } public get realDollarMean(): number { return this._realDollarMean;} private _realDollarMean: number;
    public set dollarRateMean(v: number) { this._dollarRateMean = v; } public get dollarRateMean(): number { return this._dollarRateMean;} private _dollarRateMean: number;
    public set dollarPriceMean(v: number) { this._dollarPriceMean = v; } public get dollarPriceMean(): number { return this._dollarPriceMean;} private _dollarPriceMean: number;
    public set currentDollarMean(v: number) { this._currentDollarMean = v; } public get currentDollarMean(): number { return this._currentDollarMean;} private _currentDollarMean: number;
    
    calculateSum(){
        if (this.items.length != 0){
            this.dataContext.calculateSum();
        }
    }
    
    load(){
        this.dataContext.load();
    }
    exportExcel(){
        this.dataContext.exportExcel();
    }
}
